import type { FaireProductEntity } from "../../entity_types/product";

export const p_mb4beqw8nq: FaireProductEntity = {
  token: "p_mb4beqw8nq",
  type: "product",
  name: "NEW! HOGS Bangle Bracelets University of Arkansas GameDay",
  brandToken: "b_af92w55rjq",
  brandName: "Steele Sloan Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/9d20df5e605adc81aa807ee3469818541bfb8907362aaf491526ff552c941e64.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6cbcf458e5b493beafdd3126f9320f00dcaa9b9fa9ec0e82a4037ca61efbd9c6.jpeg",
    "https://cdn.faire.com/fastly/966f989824c794f70d3c84b43c1c7c815a23e08211bf30fe50584a5f6bb1383a.jpeg",
    "https://cdn.faire.com/fastly/2c907931e767dc9600309ab37313fa30cbfbf6bdd8c897aee57d1168b76bd9f7.jpeg",
  ],
  priceDollars: 44.34,
  description:
    "NEW! HOGS Bangle Bracelets Tarnish Resistant Stainless Steel Officially Licensed \nTotal Statement Piece! Y'all these are AWESOME!!! you will absolutely LOVE! NEW!  Absolutely LOVE this newest style - best way to show your HOGS spirit with these tarnish resistant stainless steel HOGS bangle bracelets  - These are an Officially Licensed Product. These have a very slight flexibility to gently close or open on your wrist for YOUR size.  Total length end to end is 6 1/4 inch, height is just about  1 1/4 inch and they are about 1/8 inch thickness  - ... #razorbacks #arkansasgift #giftsforarkansasfans #universityofarkansas #woopig #arkansasbaseball #arkansasfootball #banglebracelets  #razorbacksgameday\nYou may also like our Go Hogs Gold Stud earrings ",
  tags: [],
  msrpDollars: 66.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:51.834Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
